import { render } from "./CruzNotification.vue?vue&type=template&id=f79992a8&scoped=true"
import script from "./CruzNotification.vue?vue&type=script&lang=js"
export * from "./CruzNotification.vue?vue&type=script&lang=js"

import "./CruzNotification.vue?vue&type=style&index=0&id=f79992a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f79992a8"]])

export default __exports__